<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible"
    style="text-align: left">
      <el-form :model="dataForm" :rules="dataRule" ref="dataForm"
               label-width="150px">
               <el-form-item label="岗点" prop="gdid" >
                    <el-select clearable style="width: 100%" @change="changeGdxx"  filterable v-model="dataForm.gdid"     placeholder="请选择岗点">
                        <el-option
                                v-for="item in gdList"
                                :key="item.gdid"
                                :label="item.gdmc"
                                :value="item.gdid">
                        </el-option>
                    </el-select>
                </el-form-item>
							<el-form-item label="部门" prop="bmid" >
                  <el-select clearable style="width: 100%" :disabled="deptdisable" @change="changeDepts"  filterable v-model="dataForm.bmid"     placeholder="请选择部门">
                      <el-option
                              v-for="item in depts"
                              :key="item.bmid"
                              :label="item.bmmc"
                              :value="item.bmid"
                              :disabled="deptdisable">
                      </el-option>
                  </el-select>
              </el-form-item>
							<el-form-item label="责任人姓名" prop="userid" >
                <el-select clearable style="width: 100%"  reserve-keyword filterable remote :remote-method="searchChecker1" @change="changeZrrxm" v-model="dataForm.userid" placeholder="输入姓名" :loading="loading1">
                  <el-option
                          v-for="item in approvers"
                          :key="item.id"
                          :label="item.xm"
                          :value="item.id">
                    <span style="float: left">{{ item.xm }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.username }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
							<el-form-item label="电话号码" prop="dhhm">
								<el-input clearable @change="changeIndex" v-model="dataForm.dhhm" placeholder="电话号码"></el-input>
							</el-form-item>
							<el-form-item label="短号" prop="dh">
								<el-input clearable @change="changeIndex" v-model="dataForm.dh" placeholder="短号"></el-input>
							</el-form-item>
  
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
      </span>
    </el-dialog>
  </template>
  
  <script>
    export default {
  
      data () {
        const validateNumber = (rule, value, callback) => {
          if(value) {
            var patrn = /^\d+(\.\d+)?$/;
            if (!patrn.exec(value)) {
              callback(new Error('请填写数字'))
            } else {
              callback()
            }
          } else {
            if(rule.field === 'dhhm') {
              callback(new Error('请输入电话号码'))
            } else {
              callback()
            }
          }
        }
        return {
          visible: false,
          deptdisable: false,
          gdList: [],
          depts: [],
          loading1:false,
          approvers:[],
          dataForm: {
            id: '',
            gdid: '',
            gdmc: '',
            userid: '',
            zrrgh: '',
            zrrxm: '',
            dhhm: '',
            bmid: '',
            bmmc: '',
            dh: ''
          },
          dataRule: {
            gdid: [
              {required: true, message: '请选择岗点', trigger: 'blur'}
            ],
            bmid: [
              {required: true, message: '请选择部门', trigger: 'blur'}
            ],
            userid: [
              {required: true, message: '请输入姓名', trigger: 'blur'}
            ],
            dhhm:[
              {required: true, validator:validateNumber, trigger: 'blur'}
            ],
            dh:[
              {validator:validateNumber,trigger: 'blur'}
            ]
          }
        }
      },
      methods: {
        init (id) {
          this.dataForm.id = id
          this.visible = true
          this.approvers=[]
          this.$nextTick(() => {
            this.$refs['dataForm'].resetFields()
            if(this.dataForm.id) {
              this.$http({
                url: '/bjba/addressBook/info/'+this.dataForm.id,
                method: 'get'
              }).then(({data}) => {
                this.dataForm = data.data
                if(data.data.approvers) {
                  this.approvers.push(data.data.approvers);
                }
              })
            }
          })
          this.getDepts()
          this.getGd()
        },

        getDepts() {
            let that = this;
            this.$request.get('/bjba/kqtj/getFirstMentForUser',{
                params: {
                    userid:this.$store.getters.username
                }
            }).then(res => {
                that.depts = res.data
                if(this.depts && this.depts[0]) {
                    var zzdyqc = this.$store.getters.user.zzdyqc;
                    if(zzdyqc != this.CONST_ZN_BM) {
                        var zw = this.$store.getters.user.zw;
                        if(zw) {
                            if(zw=='01'||zw=='02'||zw=='03') {
                                this.searchForm.bmid = that.depts[0].bmid
                                this.deptdisable = true
                            }
                        }
                    }
                }
            })
        },

		    getGd() {
            this.$request.get('/bjba/map/queryAll').then(res => {
                this.gdList = res.data.data
            })
        },

        changeGdxx(e) {
          console.log("改变岗点信息的值：",e)
        },

        changeDepts(e) {
          console.log("改变部门信息的值：",e)
        },

        changeZrrxm(e) {
          console.log("改变责任人姓名的值：",e)
        },

        searchChecker1(query) {
          console.log(query)
          if (query !== '') {
            this.loading1 = true;

            this.$request.get('/bjba/yhgl/findUserListByxm',{
              params: {
                xm:query
              }

            }).then(res => {
              this.loading1 =false
              this.approvers = res.data.data
            })
          } else {
            this.approvers = [];
          }
        },

        // 表单提交
        dataFormSubmit () {
          this.$refs['dataForm'].validate((valid) => {
            if (valid) {
                console.log("要提交的表单信息为：",this.dataForm)
                  this.$http({
                    url: `/bjba/addressBook/`+(this.dataForm.id?'update':'save'),
                    method: 'post',
                    data: this.dataForm
                  }).then(({data}) => {
                    if (data && data.code === 200) {
                      this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 1500
                      })
                      this.visible = false
                      this.$emit('refreshDataList')
                    } else if(data && data.code === 500) {
                      this.$message({
                        message: data.message,
                        type: 'error',
                        duration: 1500
                      })
                    }
                  })
            }
          })
        }

      }
    }
  </script>
  